"use strict";
exports.__esModule = true;
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromTezosResourcesRaw = exports.toTezosResourcesRaw = void 0;
function toTezosResourcesRaw(r) {
    var revealed = r.revealed, counter = r.counter;
    return { revealed: revealed, counter: counter };
}
exports.toTezosResourcesRaw = toTezosResourcesRaw;
function fromTezosResourcesRaw(r) {
    var revealed = r.revealed, counter = r.counter;
    return { revealed: revealed, counter: counter };
}
exports.fromTezosResourcesRaw = fromTezosResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    var tezosAccount = account;
    if (tezosAccount.tezosResources) {
        accountRaw.tezosResources = toTezosResourcesRaw(tezosAccount.tezosResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    var tezosResourcesRaw = accountRaw.tezosResources;
    if (tezosResourcesRaw)
        account.tezosResources =
            fromTezosResourcesRaw(tezosResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map